// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
   display: flex;
   flex-direction: row;
   justify-content: center;
   align-items: center;
}

.container_visible{
   width: 400px;
   margin: auto;
   font-family: sans-serif;
   letter-spacing: 0.5px;
}

.container_invisible{
   display: none;
   width: 400px;
   margin: auto;
   margin-top: 4%;
   font-family: sans-serif;
   letter-spacing: 0.5px;
}

.btn-outline-info {
   --bs-btn-color: #0d6efd;
   --bs-btn-border-color: #0d6efd;
   --bs-btn-hover-color: #000;
   --bs-btn-hover-bg: #0d6efdf0;
   --bs-btn-hover-border-color: #0d6efd;
   --bs-btn-focus-shadow-rgb: 13,202,240;
   --bs-btn-active-color: #000;
   --bs-btn-active-bg: #0d6efd;
   --bs-btn-active-border-color: #0d6efd;
   --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
   --bs-btn-disabled-color: #0d6efd;
   --bs-btn-disabled-bg: transparent;
   --bs-btn-disabled-border-color: #0d6efd;
   --bs-gradient: none;
}

img
{
   max-width: 100%;
   
}
.img_visible
{
   width: 250px;
   margin-top: 100%;
}
.img_invisible
{
   display: none;
   width: 250px;
   margin-top: 100%;
}

.msg-header
{
  border: 1px solid #ccc;
  width: 400px;
  height: 110px;
  border-bottom: none;
  display: inline-block;
  background-color: #0d6efd;

}
.msg-header-img
{
   border-radius: 70%;
   width: 120px;
   margin-left: 0%;
   margin-top: 0px;
   float: left;
}

.spinner-img
{
   margin-left: 50%;
   float: left;
}

.temporizador-img
{
   width: 90px;
   margin-left: 40%;
   float: left;
   
}

.logo
{
   width: 120px;
   float: left;
   margin-top: 20px;
   margin-left: 30px;
   
}

.active
{
   width: 120px;
   float: left;
   margin-top: 30px;
   margin-left: 0%;
}

.active h4
{
   font-size: 30px;
   margin-left: 0px;
   color: #fff;
}
.active h6
{
   font-size: 12px;
   margin-left: 11px;
   line-height: 2px;
   color: #fff;
}
.header-icons
{
   width: 120px;
   float: right;
   margin-top: 12px;
   margin-right: 10px;
}
.header-icons .fa
{
   color: #fff;
   cursor: pointer;
   margin: 10px;
}
.chat-page
{
   padding: 0 0 0 0;
}

.volumeButtons1
{
   width: 20px;
   float: left;
}
.volumeButtons2
{
   width: 20px;
   float: right;
}

.msg-inbox
{
   border: #ccc;
   overflow: hidden;
   padding-bottom: 0px;
   
}
.chats
{
   padding: 30px 15px 10px 25px;
  
  
}
.msg-page
{
   height: 480px;
   overflow-y: auto;

}

.received-chats-img
{
   display: inline-block;
   width: 25px;
   float: right;
   

}
.received-msg
{
   display: inline-block;
   padding: 0 0 0 10px;
   vertical-align: top;
   width: 90%;
   height: 90%;
}

.invisible
{
   display: none;
}


.received-msg-inbox
{
   width: 85%;

}
.received-msg-inbox p
{
   background: #efefef none repeat scroll 0 0;
   border-radius: 10px;
   color: #646464;
   font-size: 14px;
   margin: 0;
   padding: 5px 10px 5px 12px;
   width: 100%;
   
}
.time
{
   color: #777;
   display: block;
   font-size: 11px;
   margin:8px 0 0;
}

.outgoing-chats
{
   overflow: hidden;
   margin: 26px 20px;
   

}
.outgoing-chats-msg p
{
  background: #0d6efd none repeat scroll 0 0;
  color: #fff;
  border-radius: 10px;
  font-size: 14px;
  margin: 0;
  padding: 5px 10px 5px 12px;
  width: 100%;

}

.outgoing-chats-msg
{
  float: left;
  width: 80%;
  margin-left: 20%;

}
.outgoing-chats-img
{
  display: inline-block;
  width: 25px;
  float: right;

}
.msg-bottom
{
   position: relative;
   height: 100px;
   background-color: #0d6efd;
}
.input-group
{
   float: right;
   margin-top: 25px;
   margin-left: 20px;
   margin-right: 5px;
   outline: none !important;
   border-radius: 20px;
   width: 380px !important;
   height: 50px;
   background-color: #fff;
}
.form-control
{
   border: none !important;
   border-radius: 20px !important;
   width: 120px;
   margin-top: 8px;
   
}
.input-group-text
{
   background: transparent !important;
   border: none !important;
   
}
.input-group .fa
{
  color: #0d6efd;
  float: right;
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 12px;
}
.bottom-icons
{
   float:left;
   margin-top: 5px;
   width: 150px !important;
   margin-left: 12px;  
}
.bottom-icons .fa
{
   color: #fff;
   padding: 5px;
}
.form-control:focus
{
   border-color: none !important;
   box-shadow: none !important;
   border-radius: 20px;
}

/* Esconder a scrollbar no Chrome, Safari e Opera */
::-webkit-scrollbar {
   display: none;
}`, "",{"version":3,"sources":["webpack://./src/css/style.css"],"names":[],"mappings":"AAAA;GACG,aAAa;GACb,mBAAmB;GACnB,uBAAuB;GACvB,mBAAmB;AACtB;;AAEA;GACG,YAAY;GACZ,YAAY;GACZ,uBAAuB;GACvB,qBAAqB;AACxB;;AAEA;GACG,aAAa;GACb,YAAY;GACZ,YAAY;GACZ,cAAc;GACd,uBAAuB;GACvB,qBAAqB;AACxB;;AAEA;GACG,uBAAuB;GACvB,8BAA8B;GAC9B,0BAA0B;GAC1B,4BAA4B;GAC5B,oCAAoC;GACpC,qCAAqC;GACrC,2BAA2B;GAC3B,2BAA2B;GAC3B,qCAAqC;GACrC,4DAA4D;GAC5D,gCAAgC;GAChC,iCAAiC;GACjC,uCAAuC;GACvC,mBAAmB;AACtB;;AAEA;;GAEG,eAAe;;AAElB;AACA;;GAEG,YAAY;GACZ,gBAAgB;AACnB;AACA;;GAEG,aAAa;GACb,YAAY;GACZ,gBAAgB;AACnB;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;;AAE3B;AACA;;GAEG,kBAAkB;GAClB,YAAY;GACZ,eAAe;GACf,eAAe;GACf,WAAW;AACd;;AAEA;;GAEG,gBAAgB;GAChB,WAAW;AACd;;AAEA;;GAEG,WAAW;GACX,gBAAgB;GAChB,WAAW;;AAEd;;AAEA;;GAEG,YAAY;GACZ,WAAW;GACX,gBAAgB;GAChB,iBAAiB;;AAEpB;;AAEA;;GAEG,YAAY;GACZ,WAAW;GACX,gBAAgB;GAChB,eAAe;AAClB;;AAEA;;GAEG,eAAe;GACf,gBAAgB;GAChB,WAAW;AACd;AACA;;GAEG,eAAe;GACf,iBAAiB;GACjB,gBAAgB;GAChB,WAAW;AACd;AACA;;GAEG,YAAY;GACZ,YAAY;GACZ,gBAAgB;GAChB,kBAAkB;AACrB;AACA;;GAEG,WAAW;GACX,eAAe;GACf,YAAY;AACf;AACA;;GAEG,gBAAgB;AACnB;;AAEA;;GAEG,WAAW;GACX,WAAW;AACd;AACA;;GAEG,WAAW;GACX,YAAY;AACf;;AAEA;;GAEG,YAAY;GACZ,gBAAgB;GAChB,mBAAmB;;AAEtB;AACA;;GAEG,4BAA4B;;;AAG/B;AACA;;GAEG,aAAa;GACb,gBAAgB;;AAEnB;;AAEA;;GAEG,qBAAqB;GACrB,WAAW;GACX,YAAY;;;AAGf;AACA;;GAEG,qBAAqB;GACrB,mBAAmB;GACnB,mBAAmB;GACnB,UAAU;GACV,WAAW;AACd;;AAEA;;GAEG,aAAa;AAChB;;;AAGA;;GAEG,UAAU;;AAEb;AACA;;GAEG,0CAA0C;GAC1C,mBAAmB;GACnB,cAAc;GACd,eAAe;GACf,SAAS;GACT,0BAA0B;GAC1B,WAAW;;AAEd;AACA;;GAEG,WAAW;GACX,cAAc;GACd,eAAe;GACf,cAAc;AACjB;;AAEA;;GAEG,gBAAgB;GAChB,iBAAiB;;;AAGpB;AACA;;EAEE,0CAA0C;EAC1C,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,0BAA0B;EAC1B,WAAW;;AAEb;;AAEA;;EAEE,WAAW;EACX,UAAU;EACV,gBAAgB;;AAElB;AACA;;EAEE,qBAAqB;EACrB,WAAW;EACX,YAAY;;AAEd;AACA;;GAEG,kBAAkB;GAClB,aAAa;GACb,yBAAyB;AAC5B;AACA;;GAEG,YAAY;GACZ,gBAAgB;GAChB,iBAAiB;GACjB,iBAAiB;GACjB,wBAAwB;GACxB,mBAAmB;GACnB,uBAAuB;GACvB,YAAY;GACZ,sBAAsB;AACzB;AACA;;GAEG,uBAAuB;GACvB,8BAA8B;GAC9B,YAAY;GACZ,eAAe;;AAElB;AACA;;GAEG,kCAAkC;GAClC,uBAAuB;;AAE1B;AACA;;EAEE,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;;GAEG,UAAU;GACV,eAAe;GACf,uBAAuB;GACvB,iBAAiB;AACpB;AACA;;GAEG,WAAW;GACX,YAAY;AACf;AACA;;GAEG,6BAA6B;GAC7B,2BAA2B;GAC3B,mBAAmB;AACtB;;AAEA,mDAAmD;AACnD;GACG,aAAa;AAChB","sourcesContent":[".App {\n   display: flex;\n   flex-direction: row;\n   justify-content: center;\n   align-items: center;\n}\n\n.container_visible{\n   width: 400px;\n   margin: auto;\n   font-family: sans-serif;\n   letter-spacing: 0.5px;\n}\n\n.container_invisible{\n   display: none;\n   width: 400px;\n   margin: auto;\n   margin-top: 4%;\n   font-family: sans-serif;\n   letter-spacing: 0.5px;\n}\n\n.btn-outline-info {\n   --bs-btn-color: #0d6efd;\n   --bs-btn-border-color: #0d6efd;\n   --bs-btn-hover-color: #000;\n   --bs-btn-hover-bg: #0d6efdf0;\n   --bs-btn-hover-border-color: #0d6efd;\n   --bs-btn-focus-shadow-rgb: 13,202,240;\n   --bs-btn-active-color: #000;\n   --bs-btn-active-bg: #0d6efd;\n   --bs-btn-active-border-color: #0d6efd;\n   --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n   --bs-btn-disabled-color: #0d6efd;\n   --bs-btn-disabled-bg: transparent;\n   --bs-btn-disabled-border-color: #0d6efd;\n   --bs-gradient: none;\n}\n\nimg\n{\n   max-width: 100%;\n   \n}\n.img_visible\n{\n   width: 250px;\n   margin-top: 100%;\n}\n.img_invisible\n{\n   display: none;\n   width: 250px;\n   margin-top: 100%;\n}\n\n.msg-header\n{\n  border: 1px solid #ccc;\n  width: 400px;\n  height: 110px;\n  border-bottom: none;\n  display: inline-block;\n  background-color: #0d6efd;\n\n}\n.msg-header-img\n{\n   border-radius: 70%;\n   width: 120px;\n   margin-left: 0%;\n   margin-top: 0px;\n   float: left;\n}\n\n.spinner-img\n{\n   margin-left: 50%;\n   float: left;\n}\n\n.temporizador-img\n{\n   width: 90px;\n   margin-left: 40%;\n   float: left;\n   \n}\n\n.logo\n{\n   width: 120px;\n   float: left;\n   margin-top: 20px;\n   margin-left: 30px;\n   \n}\n\n.active\n{\n   width: 120px;\n   float: left;\n   margin-top: 30px;\n   margin-left: 0%;\n}\n\n.active h4\n{\n   font-size: 30px;\n   margin-left: 0px;\n   color: #fff;\n}\n.active h6\n{\n   font-size: 12px;\n   margin-left: 11px;\n   line-height: 2px;\n   color: #fff;\n}\n.header-icons\n{\n   width: 120px;\n   float: right;\n   margin-top: 12px;\n   margin-right: 10px;\n}\n.header-icons .fa\n{\n   color: #fff;\n   cursor: pointer;\n   margin: 10px;\n}\n.chat-page\n{\n   padding: 0 0 0 0;\n}\n\n.volumeButtons1\n{\n   width: 20px;\n   float: left;\n}\n.volumeButtons2\n{\n   width: 20px;\n   float: right;\n}\n\n.msg-inbox\n{\n   border: #ccc;\n   overflow: hidden;\n   padding-bottom: 0px;\n   \n}\n.chats\n{\n   padding: 30px 15px 10px 25px;\n  \n  \n}\n.msg-page\n{\n   height: 480px;\n   overflow-y: auto;\n\n}\n\n.received-chats-img\n{\n   display: inline-block;\n   width: 25px;\n   float: right;\n   \n\n}\n.received-msg\n{\n   display: inline-block;\n   padding: 0 0 0 10px;\n   vertical-align: top;\n   width: 90%;\n   height: 90%;\n}\n\n.invisible\n{\n   display: none;\n}\n\n\n.received-msg-inbox\n{\n   width: 85%;\n\n}\n.received-msg-inbox p\n{\n   background: #efefef none repeat scroll 0 0;\n   border-radius: 10px;\n   color: #646464;\n   font-size: 14px;\n   margin: 0;\n   padding: 5px 10px 5px 12px;\n   width: 100%;\n   \n}\n.time\n{\n   color: #777;\n   display: block;\n   font-size: 11px;\n   margin:8px 0 0;\n}\n\n.outgoing-chats\n{\n   overflow: hidden;\n   margin: 26px 20px;\n   \n\n}\n.outgoing-chats-msg p\n{\n  background: #0d6efd none repeat scroll 0 0;\n  color: #fff;\n  border-radius: 10px;\n  font-size: 14px;\n  margin: 0;\n  padding: 5px 10px 5px 12px;\n  width: 100%;\n\n}\n\n.outgoing-chats-msg\n{\n  float: left;\n  width: 80%;\n  margin-left: 20%;\n\n}\n.outgoing-chats-img\n{\n  display: inline-block;\n  width: 25px;\n  float: right;\n\n}\n.msg-bottom\n{\n   position: relative;\n   height: 100px;\n   background-color: #0d6efd;\n}\n.input-group\n{\n   float: right;\n   margin-top: 25px;\n   margin-left: 20px;\n   margin-right: 5px;\n   outline: none !important;\n   border-radius: 20px;\n   width: 380px !important;\n   height: 50px;\n   background-color: #fff;\n}\n.form-control\n{\n   border: none !important;\n   border-radius: 20px !important;\n   width: 120px;\n   margin-top: 8px;\n   \n}\n.input-group-text\n{\n   background: transparent !important;\n   border: none !important;\n   \n}\n.input-group .fa\n{\n  color: #0d6efd;\n  float: right;\n  margin-left: 10px;\n  margin-right: 10px;\n  margin-top: 12px;\n}\n.bottom-icons\n{\n   float:left;\n   margin-top: 5px;\n   width: 150px !important;\n   margin-left: 12px;  \n}\n.bottom-icons .fa\n{\n   color: #fff;\n   padding: 5px;\n}\n.form-control:focus\n{\n   border-color: none !important;\n   box-shadow: none !important;\n   border-radius: 20px;\n}\n\n/* Esconder a scrollbar no Chrome, Safari e Opera */\n::-webkit-scrollbar {\n   display: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
